const MEDIA_URL = `${process.env.REACT_APP_PRODUCT_BASE_URL}/merch-preview/`;

export const getImageAndMaskWithProductId = (productId: number) => [
  `${MEDIA_URL}${productId}.png`,
  `${MEDIA_URL}${productId}-mask.png`,
  `${MEDIA_URL}${productId}-back.png`,
];

export const getImagePositionAndMaskWithProductId = (productId: number) => [
  `${MEDIA_URL}${productId}-mask.png`,
  `${MEDIA_URL}${productId}-mask-back.png`,
];
